// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"9d01b6a2","543":"7b9d89f0"}[chunkId] + ".chunk.js";
};